module.exports = __webpack_public_path__ + "static/media/no-records-dark.e3784176.svg";